import {
  matchPath,
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom'

import BrokerRoute from '@/containers/brokerContainer'
import DataContainer from '@/containers/dataContainer'
import DebugContainter from '@/containers/debug'
import MotorTradeContainer from '@/containers/motorTradeContainer'
import BrokerBuy from '@/pages/BrokerBuy'
import Home from '@/pages/Home'
import MotorTrade from '@/pages/MotorTrade'
import CommercialCombined from '@/steps/CommercialCombined'
import BrokerBuyRouteController from '@/steps/CommercialCombined/BrokerBuyRouteController'
import MotorTradeBuyRouteController from '@/steps/MotorTrade/MotorTradeBuyRouteController'
import { RouterEnum } from '@/router/base'

import { getMTEmail } from './api/motorTrade'
import BrokerBuyReferral from './steps/CommercialCombined/Referral/Referral'
import MotorTradePopulate from './steps/MotorTrade'
import MTBrokerBuyReferral from './steps/MotorTrade/MTReferral'
import {
  brokerDetailStore,
  brokerGuidStore,
  clientStore,
  commercialCombinedFormStore,
  isBackofficeStore,
  isMTAStore,
} from './store/CommercialCombinedFormStore'
import {
  existingTradePlatesStore,
  isMtBackofficeStore,
  motorTradeFormStore,
  motorTradeGuidStore,
  mtBrokerDetailStore,
  mtClientStore,
} from './store/MotorTradeFormStore'

const backOfficeBaseURL = import.meta.env.VITE_BACKOFFICE_URL
const backOfficeDashboardURL = backOfficeBaseURL + 'back-office/dashboard'

const brokerBaseURL = import.meta.env.VITE_COVERX_BROKER_DASH
const brokerDashboardURL = brokerBaseURL + '/broker/dashboard'

function App() {
  return (
    <>
      <DebugContainter />
      <Router>
        <DataContainer>
          <Routes>
            <Route index element={<Home />} />
            <Route path="*" element={<RouteGuard />} />

            <Route
              path="/broker/clean/buy/motortrade-roadrisks"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/new-quote-client/buy/motortrade-roadrisks"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/buy/motortrade-roadrisks"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/new-quote/buy/motortrade-roadrisks"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route path="/back-office/new-quote/buy/motortrade-roadrisks">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />

                <Route
                  path={RouterEnum.NEW_QUOTE_BROKER}
                  element={<MotorTradePopulate />}
                />

                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/broker/buy/motortrade-roadrisks">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />
                <Route path={':guid'} element={<MotorTradePopulate />} />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/back-office/buy/motortrade-roadrisks">
              <Route element={<MotorTradePopulate />}>
                <Route index element={<MotorTrade />} />
                <Route path={':guid'} element={<MotorTradePopulate />} />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/back-office/new-quote-client/buy/motortrade-roadrisks">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />
                <Route
                  path=":brokerId/:brokerName/:clientId/:guid"
                  element={<MotorTradePopulate />}
                />
                <Route
                  path={':brokerId/:brokerName/:clientId'}
                  element={<MotorTradePopulate />}
                />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route
              path={'motortrade-roadrisks'}
              element={<MotorTradeContainer />}
            >
              <Route index element={<MotorTrade />} />
              <Route
                path="steps/:step"
                element={<MotorTradeBuyRouteController />}
              />
            </Route>

            <Route path={RouterEnum.MOTOR_TRADE}>
              <Route
                path={RouterEnum.MOTOR_TRADE_BUY}
                element={<MotorTradeContainer />}
              >
                <Route index element={<MotorTrade />} />
                <Route
                  path=":step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/motortrade-roadrisks/broker">
              <Route
                path="refer/:guid"
                element={<MTBrokerBuyReferral />}
              ></Route>
            </Route>

            <Route
              path="/broker/clean/buy/motortrade-roadrisks-s2"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/new-quote-client/buy/motortrade-roadrisks-s2"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/buy/motortrade-roadrisks-s2"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/new-quote/buy/motortrade-roadrisks-s2"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route path="/back-office/new-quote/buy/motortrade-roadrisks-s2">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />

                <Route
                  path={RouterEnum.NEW_QUOTE_BROKER}
                  element={<MotorTradePopulate />}
                />

                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/broker/buy/motortrade-roadrisks-s2">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />
                <Route path={':guid'} element={<MotorTradePopulate />} />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/back-office/buy/motortrade-roadrisks-s2">
              <Route element={<MotorTradePopulate />}>
                <Route index element={<MotorTrade />} />
                <Route path={':guid'} element={<MotorTradePopulate />} />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/back-office/new-quote-client/buy/motortrade-roadrisks-s2">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />
                <Route
                  path=":brokerId/:brokerName/:clientId/:guid"
                  element={<MotorTradePopulate />}
                />
                <Route
                  path={':brokerId/:brokerName/:clientId'}
                  element={<MotorTradePopulate />}
                />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route
              path={'motortrade-roadrisks-s2'}
              element={<MotorTradeContainer />}
            >
              <Route index element={<MotorTrade />} />
              <Route
                path="steps/:step"
                element={<MotorTradeBuyRouteController />}
              />
            </Route>

            <Route path={RouterEnum.MOTOR_TRADE}>
              <Route
                path={RouterEnum.MOTOR_TRADE_BUY}
                element={<MotorTradeContainer />}
              >
                <Route index element={<MotorTrade />} />
                <Route
                  path=":step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/motortrade-roadrisks-s2/broker">
              <Route
                path="refer/:guid"
                element={<MTBrokerBuyReferral isAlternate={true} />}
              ></Route>
            </Route>

            <Route
              path="/broker/clean/buy/motortrade-roadrisks-rtl"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/new-quote-client/buy/motortrade-roadrisks-rtl"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/buy/motortrade-roadrisks-rtl"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/new-quote/buy/motortrade-roadrisks-rtl"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route path="/back-office/new-quote/buy/motortrade-roadrisks-rtl">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />

                <Route
                  path={RouterEnum.NEW_QUOTE_BROKER}
                  element={<MotorTradePopulate />}
                />

                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/broker/buy/motortrade-roadrisks-rtl">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />
                <Route path={':guid'} element={<MotorTradePopulate />} />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/back-office/buy/motortrade-roadrisks-rtl">
              <Route element={<MotorTradePopulate />}>
                <Route index element={<MotorTrade />} />
                <Route path={':guid'} element={<MotorTradePopulate />} />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/back-office/new-quote-client/buy/motortrade-roadrisks-rtl">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />
                <Route
                  path=":brokerId/:brokerName/:clientId/:guid"
                  element={<MotorTradePopulate />}
                />
                <Route
                  path={':brokerId/:brokerName/:clientId'}
                  element={<MotorTradePopulate />}
                />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route
              path={'motortrade-roadrisks-rtl'}
              element={<MotorTradeContainer />}
            >
              <Route index element={<MotorTrade />} />
              <Route
                path="steps/:step"
                element={<MotorTradeBuyRouteController />}
              />
            </Route>

            <Route path={RouterEnum.MOTOR_TRADE}>
              <Route
                path={RouterEnum.MOTOR_TRADE_BUY}
                element={<MotorTradeContainer />}
              >
                <Route index element={<MotorTrade />} />
                <Route
                  path=":step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/motortrade-roadrisks-rtl/broker">
              <Route
                path="refer/:guid"
                element={<MTBrokerBuyReferral isAlternate={true} />}
              ></Route>
            </Route>

            <Route
              path="/broker/clean/buy/motortrade-roadrisks-s2-rtl"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/new-quote-client/buy/motortrade-roadrisks-s2-rtl"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/buy/motortrade-roadrisks-s2-rtl"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route
              path="/back-office/clean/new-quote/buy/motortrade-roadrisks-s2-rtl"
              element={<MotorTradeClean />}
            >
              <Route path="*" element={<MotorTradeClean />} />
            </Route>

            <Route path="/back-office/new-quote/buy/motortrade-roadrisks-s2-rtl">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />

                <Route
                  path={RouterEnum.NEW_QUOTE_BROKER}
                  element={<MotorTradePopulate />}
                />

                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/broker/buy/motortrade-roadrisks-s2-rtl">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />
                <Route path={':guid'} element={<MotorTradePopulate />} />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/back-office/buy/motortrade-roadrisks-s2-rtl">
              <Route element={<MotorTradePopulate />}>
                <Route index element={<MotorTrade />} />
                <Route path={':guid'} element={<MotorTradePopulate />} />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/back-office/new-quote-client/buy/motortrade-roadrisks-s2-rtl">
              <Route element={<MotorTradeContainer />}>
                <Route index element={<MotorTrade />} />
                <Route
                  path=":brokerId/:brokerName/:clientId/:guid"
                  element={<MotorTradePopulate />}
                />
                <Route
                  path={':brokerId/:brokerName/:clientId'}
                  element={<MotorTradePopulate />}
                />
                <Route
                  path="steps/:step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route
              path={'motortrade-roadrisks-s2-rtl'}
              element={<MotorTradeContainer />}
            >
              <Route index element={<MotorTrade />} />
              <Route
                path="steps/:step"
                element={<MotorTradeBuyRouteController />}
              />
            </Route>

            <Route path={RouterEnum.MOTOR_TRADE}>
              <Route
                path={RouterEnum.MOTOR_TRADE_BUY}
                element={<MotorTradeContainer />}
              >
                <Route index element={<MotorTrade />} />
                <Route
                  path=":step"
                  element={<MotorTradeBuyRouteController />}
                />
              </Route>
            </Route>

            <Route path="/motortrade-roadrisks-s2-rtl/broker">
              <Route
                path="refer/:guid"
                element={<MTBrokerBuyReferral isAlternate={true} />}
              ></Route>
            </Route>

            <Route
              path={RouterEnum.COMMERCIAL_COMBINED}
              element={<BrokerRoute />}
            >
              <Route index element={<BrokerBuy />} />
              <Route
                path="steps/:step"
                element={<BrokerBuyRouteController />}
              />
            </Route>

            {/* // BROKER SCENARIO */}
            <Route path={RouterEnum.BROKER}>
              <Route path="clean">
                <Route path="*" element={<BrokerBackOfficeClean />} />
              </Route>
              <Route
                path={RouterEnum.BROKER_REFER}
                element={<BrokerBuyReferral />}
              />
              <Route path={RouterEnum.BROKER_BUY} element={<BrokerRoute />}>
                <Route index element={<BrokerBuy />} />
                <Route
                  path={RouterEnum.BROKER_BUY_COMMERCIAL_COMBINED}
                  element={<CommercialCombined />}
                />
                <Route
                  path="steps/:step"
                  element={<BrokerBuyRouteController />}
                />
              </Route>
            </Route>

            {/* // BACKOFFICE SCENARIO */}
            <Route path={RouterEnum.BACKOFFICE}>
              <Route path="clean">
                <Route path="*" element={<BrokerBackOfficeClean />} />
              </Route>

              {/* // NEW QUOTE */}
              <Route path={RouterEnum.NEW_QUOTE} element={<BrokerRoute />}>
                <Route index element={<BrokerBuy />} />
                <Route
                  path={RouterEnum.NEW_QUOTE_BROKER}
                  element={<CommercialCombined />}
                />

                <Route
                  path="steps/:step"
                  element={<BrokerBuyRouteController />}
                />
              </Route>

              {/* // BUY */}
              <Route
                path={RouterEnum.BROKER_BUY}
                element={<CommercialCombined />}
              >
                <Route index element={<BrokerBuy />} />
                <Route
                  path={RouterEnum.BROKER_BUY_COMMERCIAL_COMBINED}
                  element={<CommercialCombined />}
                />
                <Route
                  path="steps/:step"
                  element={<BrokerBuyRouteController />}
                />
              </Route>

              {/* // NEW QUOTE CLIENT */}
              <Route
                path={RouterEnum.NEW_QUOTE_CLIENT}
                element={<BrokerRoute />}
              >
                <Route path={RouterEnum.BROKER_BUY}>
                  <Route
                    path=":brokerId/:brokerName/:clientId"
                    element={<CommercialCombined />}
                  />

                  <Route
                    path=":brokerId/:brokerName/:clientId/:guid"
                    element={<CommercialCombined />}
                  />

                  <Route
                    path="steps/:step"
                    element={<BrokerBuyRouteController />}
                  />
                </Route>
              </Route>
            </Route>
          </Routes>
        </DataContainer>
      </Router>
    </>
  )
}

export default App

const RouteGuard = () => {
  const { pathname } = useLocation()
  const isMatch = Object.entries(RouterEnum).some(([, path]) =>
    matchPath(path, pathname)
  )

  if (!isMatch) {
    return <Navigate to={RouterEnum.HOME} />
  }
  return <></>
}

const BrokerBackOfficeClean = () => {
  const CCReset = commercialCombinedFormStore.getState().CCReset
  const guidReset = brokerGuidStore.getState().guidReset
  const brokerReset = brokerDetailStore.getState().brokerReset
  const clientReset = clientStore.getState().clientReset
  const backofficeReset = isBackofficeStore.getState().backofficeReset
  const mtaReset = isMTAStore.getState().mtaReset

  CCReset()
  guidReset()
  brokerReset()
  clientReset()
  backofficeReset()
  mtaReset()

  window.location.href = window.location.href
    .replace('/back-office/clean/', '/back-office/')
    .replace('/broker/clean/', '/broker/')

  return null
}

const MotorTradeClean = () => {
  const guidReset = motorTradeGuidStore.getState().guidReset
  const resetForm = motorTradeFormStore.getState().reset
  const brokerReset = mtBrokerDetailStore.getState().brokerReset
  const backofficeReset = isMtBackofficeStore.getState().backofficeReset
  const clientReset = mtClientStore.getState().clientReset
  const tradesReset = existingTradePlatesStore.getState().tradeReset

  sessionStorage.removeItem('authBroker')
  sessionStorage.removeItem('authBO')

  guidReset()
  resetForm()
  brokerReset()
  backofficeReset()
  clientReset()
  tradesReset()

  getMTEmail()
    .then(({ data }) => {
      if (window.location.pathname.includes('/broker/')) {
        sessionStorage.setItem('authBroker', JSON.stringify(data.email))
      } else {
        sessionStorage.setItem('authBO', JSON.stringify(data.email))
      }
      window.location.href = window.location.href
        .replace('/back-office/clean/', '/back-office/')
        .replace('/broker/clean/', '/broker/')
    })
    .catch(() => {
      if (window.location.pathname.includes('/back-office/')) {
        window.location.href = backOfficeDashboardURL
      } else {
        window.location.href = brokerDashboardURL
      }
    })

  return null
}
